import React, { useEffect } from 'react'
import {
  CardText, CardBody,
  CardTitle, Container, Row, Col
} from 'reactstrap'
import ButtonNextWithLine from './ButtonNextWithLine'
import ButtonPrevWithLine from './ButtonPrevWithLine'
import RangeSlider from './RangeSlider'
import ButtonNext from './ButtonNext'
import ButtonPrev from './ButtonPrev'
import numeral from 'numeral'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actionCreators from '../redux/actions'
import { CustomEase } from 'gsap/CustomEase'
import { gsap } from 'gsap'
gsap.registerPlugin(CustomEase)
const houseGraphic = '/assets/animation_graphics/house.svg'
const windowGraphic = '/assets/animation_graphics/window.svg'
const dollarGraphic = '/assets/animation_graphics/dollar.svg'
const calculateStepIncrement = (value) => {
  if (!value) {
    return 1000
  }
  if (value <= 20000) {
    return 1000
  } else if (value >= 20000 && value <= 75000) {
    return 5000
  } else if (value >= 75000 && value <= 250000) {
    return 25000
  } else if (value >= 250000 && value <= 500000) {
    return 50000
  } else if (value >= 500000 && value <= 1000000) {
    return 100000
  }
}

function Slide5 ({ isActive, onNextRequested, onPrevRequested, onIncrementProgress, onDecrementProgress, set, mortgage, personalBusinessDebt, calculatedStep }) {
  useEffect(() => {
    if (isActive) {
      const tl = gsap.timeline({ delay: 2 })
      const ease = CustomEase.create('custom', 'M0,0 C0,0 0.08318,0.2664 0.14193,0.43905 0.18286,0.55934 0.20602,0.62375 0.25214,0.74102 0.28228,0.81765 0.30017,0.86241 0.33637,0.93344 0.3573,0.97452 0.37697,1.00924 0.40222,1.0355 0.41087,1.0445 0.4313,1.04891 0.44292,1.04424 0.47803,1.03013 0.50891,0.9985 0.549,0.97651 0.56111,0.96986 0.5734,0.96353 0.58554,0.96601 0.64121,0.97737 0.69575,1.01266 0.75196,1.01793 0.78272,1.02082 0.81262,0.99138 0.84322,0.99016 0.86491,0.98929 0.88642,1.0117 0.90731,1.01173 0.92467,1.01175 0.94141,0.99256 0.95928,0.9903 0.97259,0.98862 1,1 1,1')
      tl.from('.house', { scaleY: 0, ease, duration: 0.7 }, '-=.1')
      tl.from('.Slide5 .dollar', { x: -380, ease, duration: 1 }, '-=.1')
      tl.from('.window', { scale: 0, ease, duration: 1 }, '-=.9')
      tl.from('.window2', { scale: 0, ease, duration: 1 }, '-=.9')
      tl.timeScale('1.1')
    }
  }, [isActive])
  const onPrevClick = () => {
    onDecrementProgress()
    onPrevRequested()
  }

  const onNextClick = () => {
    onIncrementProgress()
    onNextRequested()
  }

  return (
    <CardBody className='app-slide Slide5 w-100'>
      <Container fluid>
        <Row>
          <Col xs={{ size: 12 }} xl={{ size: 7 }} className='d-flex'>
            <div className='d-flex mt-4 pt-2 flex-wrap'>
              <div className='d-flex flex-wrap align-items-center align-items-xl-start  mt-4 pt-2 flex-column flex-xl-row '>
                <div className='graphic-wrapper '>
                  <div className='animation-wrapper'>
                    <img alt='' src={houseGraphic} className='animated-graphic house' />
                    <img alt='' src={windowGraphic} className='animated-graphic window' />
                    <img alt='' src={windowGraphic} className='animated-graphic window2' />
                    <img alt='' src={dollarGraphic} className='animated-graphic dollar' />
                  </div>
                </div>
                <div className='pl-xl-4 pr-xl-4 ml-xs-2 mr-xs-2 ml-xl-5 mr-xl-5'>
                  <CardTitle className='pb-2 pt-2'><h2>The past cannot be changed. The future is in your control.</h2></CardTitle>
                  <CardText className='pb-2'>Life Insurance can help protect your loved ones from any big debts, like mortgages or loans. However, don’t forget personal and business debts like credit card bills.</CardText>
                </div>
              </div>
            </div>
            <ButtonPrevWithLine className='d-none d-xl-block ml-5' onClick={onPrevClick} />
          </Col>
          <Col xs={12} xl={4} className='d-flex flex-column align-items-center justify-content-center pr-xl-5'>

            <h4 className='h4-slider-label'>MORTGAGE</h4>

            <RangeSlider className='ml-3 mr-xl-3 mb-5' valueKey='mortgage' step={1000} minValue={0} maxValue={1000000} updateRange={set} value={mortgage} formatLabel={(value) => `${numeral(value).format('$0,000')}`} />

            <h4 className='pt-5 h4-slider-label'>PERSONAL / BUSINESS DEBT</h4>

            <RangeSlider className='ml-3 mr-xl-3 mb-5' valueKey='personalBusinessDebt' step={calculatedStep} minValue={0} maxValue={1000000} updateRange={set} value={personalBusinessDebt} formatLabel={(value) => `${numeral(value).format('$0,000')}`} />

          </Col>
          <Col xl={1} className='d-none d-xl-block'>
            <ButtonNextWithLine onClick={onNextClick} />
          </Col>
          <Col xs={12} className='d-flex justify-content-between d-xl-none mt-5 mb-5 mb-xl-0'>
            <ButtonPrev className='ml-3' onClick={onPrevClick} />
            <ButtonNext className='mr-3' onClick={onNextClick} />
          </Col>
        </Row>
      </Container>
    </CardBody>
  )
}

const mapStateToProps = (state, props) => ({
  mortgage: state.app.mortgage,
  personalBusinessDebt: state.app.personalBusinessDebt,
  calculatedStep: calculateStepIncrement(state.app.personalBusinessDebt)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Slide5)
